import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';

export const useGuoJia = (Id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useGuoJiamethodcontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `useGuoJia-${Id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useGuoJia-loading-${Id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useGuoJia-error-${Id}`);

  // 发起支付
  const GuoJiaGet = async (customQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.guojiaList(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0 && res.data?.list?.length && res.data?.list?.[0].config && res.data?.list?.[0].config !== '') {
        const config = JSON.parse(res.data?.list?.[0].config);
        result.value = config;
      } else {
        error.value = res.message || null;
      }
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  return {
    GuoJiaGet,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
